import PropTypes from "prop-types";

// Layouts
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";
import TierRowsItem from "@/Layouts/components/Tiers/TierRowsItem";

// MUI
import { Stack } from "@mui/material";

export default function MatrixRow(props) {
	const {
		index = 0,
		item = null,
		fromDisabled = false,
		toDisabled = false,
		spaces = {
			mainSection: 100,
			columns: 100,
			totalColumns: 1,
			totalRows: 1,
			separation: 5.5,
		},
		rowsErrors = [],
		columnsErrors = [],
		firstBonusError = false,
		readOnly = false,
		spacing = 0.8,
		mainContentProps = null,
		sxMainContent = {
			minWidth: "190px",
		},
		cellsProps = {
			justifyContent: "center",
			alignItems: "center",
		},
		sxCells = {
			minWidth: "100px",
		},
		onActionUpdate = () => {},
		onChangeType = () => {},
	} = props;

	return (
		<TierRowsItem hasShadow={!(index % 2)} spaces={spaces}>
			<Stack direction={"row"} spacing={spacing}>
				<Stack {...mainContentProps} sx={sxMainContent}>
					<DoubleInput
						firstInput={{
							data: [
								{
									type: "Ordinal",
									min: 1,
									max: 10000,
									decimalsEditable: false,
									decimals: 0,
									delta: 1,
									dashed: fromDisabled,
								},
							],
							sx: { width: "70px" },
							defaultType: item?.from?.input || "Ordinal",
							value: item?.from?.value || 0,
							error: Boolean(rowsErrors?.[index]?.from),
							disabled: fromDisabled,
							readOnly: true,
						}}
						secondInput={{
							readOnly,
							data: [
								{
									type: "Ordinal",
									min: 1,
									max: 10000,
									decimalsEditable: false,
									decimals: 0,
									delta: 1,
									dashed: toDisabled,
								},
							],
							sx: { width: "70px" },
							defaultType: item?.to?.type || "Ordinal",
							value: item?.to?.value || 0,
							error: Boolean(rowsErrors?.[index]?.to),
							disabled: toDisabled,
							onActionUpdate: (value) => {
								onActionUpdate?.(index, 0, "row", "to", value);
							},
						}}
					/>
				</Stack>
				<Stack direction={"row"} spacing={spacing}>
					{item?.bonuses?.map((element, key) => {
						const bonusError = (!key && firstBonusError) || Boolean(columnsErrors?.[index]?.[key]?.["bonus"]);
						return (
							<Stack key={`${index}_${key}`} {...cellsProps} sx={sxCells}>
								<InputFormExtension
									data={[
										{
											type: "Percent",
											min: -100,
											max: 100,
											decimalsEditable: true,
											decimals: 2,
										},
										{
											type: "Dollar",
											min: Number.NEGATIVE_INFINITY,
											max: Number.MAX_VALUE,
											decimalsEditable: true,
											decimals: 2,
										},
									]}
									value={element?.bonus?.value || 0}
									defaultType={element?.bonus?.input || "Percent"}
									error={bonusError}
									disabled={readOnly}
									readOnly={readOnly}
									onChangeType={(_, input) => {
										onChangeType?.(index, key, "row", "bonus", input);
									}}
									onActionUpdate={(value) => {
										onActionUpdate?.(index, key, "row", "bonus", value);
									}}
									sx={{
										width: "95px",
									}}
								/>
							</Stack>
						);
					})}
				</Stack>
			</Stack>
		</TierRowsItem>
	);
}
MatrixRow.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	spaces: PropTypes.object,
	rowsErrors: PropTypes.array,
	columnsErrors: PropTypes.array,
	firstBonusError: PropTypes.bool,
	readOnly: PropTypes.bool,
	spacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	mainContentProps: PropTypes.object,
	sxMainContent: PropTypes.object,
	cellsProps: PropTypes.object,
	sxCells: PropTypes.object,
	onActionUpdate: PropTypes.func,
	onChangeType: PropTypes.func,
};
